import React from "react";

import logoWheels from '../../images/logoWheels.png';  // Adjust the path to your logo file accordingly


const Footer = () => (
  <div className="w-full flex md:justify-center justify-between items-center flex-col p-4 gradient-bg-footer">
    <div className="w-full flex sm:flex-row flex-col justify-between items-center my-4">
      <div className="flex flex-[0.5] justify-center items-center">
        <img src={logoWheels} alt="logo-Wheels" className="w-32" />
      </div>
      <div className="flex flex-1 justify-evenly items-center flex-wrap sm:mt-0 mt-5 w-full">
        <p className="text-white text-base text-center mx-2 cursor-pointer">Analyze</p>
        <p className="text-white text-base text-center mx-2 cursor-pointer">Authenticate</p>
        <p className="text-white text-base text-center mx-2 cursor-pointer">On-Chain</p>
      </div>
    </div>

    <div className="flex justify-center items-center flex-col mt-5">
      <p className="text-white text-sm text-center">Please feel free to contact for any question </p>
      <p className="text-white text-sm text-center font-medium mt-2">info@pmoexperts.online</p>
    </div>

    <div className="sm:w-[90%] w-full h-[0.25px] bg-gray-400 mt-5 " />

    <div className="sm:w-[90%] w-full flex justify-between items-center mt-3">
      
      <a href="https://www.linkedin.com/in/gianmarco-sirei" target="_blank" rel="noreferrer">
          <button>
              <p className="text-white text-left text-sm"> www.linkedin.com/Gianmarco-Sirei</p> 
          </button>
        </a>
      <p className="text-white text-right text-sm">All rights reserved</p>
    </div>
  </div>
);

export default Footer;